import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Button, ButtonGroup, Checkbox } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const DocumentsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.documentsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.documentTypes && caseFilter.documentTypes.length), header: lang.caseFilter.hasDocumentOfType, onDeactivate: () => caseFilterStore.clearFilter('documentTypes') },
            React.createElement(Select, { value: (caseFilter.documentTypes || []).map((documentType) => ({
                    label: lang.documentTypes[documentType],
                    value: documentType,
                })), isMulti: true, placeholder: lang.caseFilter.selectDocumentTypes, classNamePrefix: "select", options: Object.entries(DocumentTypes).map((entry) => ({
                    label: lang.documentTypes[entry[1]],
                    value: entry[1],
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        documentTypes: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.documentTypesIsSigned === 'boolean', header: lang.caseFilter.documentsIsSigned, onDeactivate: () => caseFilterStore.clearFilter('documentTypesIsSigned') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.documentTypesIsSigned, onChange: (e) => {
                    if (e.target.checked) {
                        caseFilterStore.updateFilter({
                            documentTypesIsSigned: true,
                        });
                        return;
                    }
                    caseFilterStore.clearFilter('documentTypesIsSigned');
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.hasFoundation === 'boolean', header: lang.caseFilter.hasFoundation, onDeactivate: () => caseFilterStore.clearFilter('hasFoundation') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "mini", theme: caseFilter.hasFoundation ? undefined : 'secondary', onClick: () => {
                        caseFilterStore.updateFilter({
                            hasFoundation: caseFilter.hasFoundation ? undefined : true,
                        });
                    } }, lang.caseFilter.hasFoundation),
                React.createElement(Button, { size: "mini", theme: caseFilter.hasFoundation === false ? undefined : 'secondary', onClick: () => {
                        caseFilterStore.updateFilter({
                            hasFoundation: caseFilter.hasFoundation === false ? undefined : false,
                        });
                    } }, lang.caseFilter.hasNoFoundation)))));
};
export default DocumentsGroup;
//# sourceMappingURL=DocumentsGroup.js.map